import axios from "axios";
import {Buffer} from 'buffer';
var accessTokenExpiry = 300;
var methodType, authorisationType, URL, data;
export async function callEndpoint(methodType, authorisationType, token, URL, data) {
  methodType = methodType;
  authorisationType = authorisationType;
  URL = URL;
  data = data;
  if (authorisationType === "Bearer") {
    var accessToken = getCookie("accessToken");
    if (token == "customer") {
      accessToken = getCookie("customerAccessToken");
    }
    if (accessToken == null) {
      return new Promise((resolve, reject) => {
        getAccessToken(process.env.REACT_APP_USERNAME_CINEMA_APP, process.env.REACT_APP_PASSWORD_CINEMA_APP).then((response) => {
          callEndpoint(methodType, authorisationType, token, URL, data)
            .then((response) => {
              resolve(response);
            })
            .catch(reject);
        });
      });
    } else {
      return new Promise((resolve, reject) => {
        var dataversion = getCookie("muviDefalutlang");
        if (dataversion == "en") {
          dataversion = "en-US";
        } else if (dataversion == "ar") {
          dataversion = "ar-SA";
        } else {
          dataversion = "en-US";
        }
        axios({
          url: process.env.REACT_APP_BASEURL + "" + URL,
          method: methodType,
          headers: {Authorization: "Bearer " + accessToken, dataversion: dataversion, appplatform: "WEBSITE", appversion: "1.0.0"},
          data: data,
        })
          .then((response) => {
            resolve(response);
          })
          .catch((ex) => {
            console.log('endpoint ', ex);
            if (ex.toString().includes("Network Error")) {
              reject({error: "Network Error"});
            }else if (ex.response.data.message.toLowerCase() == "unauthorized") {
              getRefreshToken().then((response) => {
                callEndpoint(methodType, authorisationType, token, URL, data)
                  .then((response) => {
                    resolve(response);
                  })
                  .catch(reject);
              });
            } else {
              reject(ex.response.data);
            }
          });
      });
    }
  } else if (authorisationType === "Basic") {
    var dataversion = getCookie("muviDefalutlang");
    if (dataversion == "en") {
      dataversion = "en-US";
    } else if (dataversion == "ar") {
      dataversion = "ar-SA";
    } else {
      dataversion = "en-US";
    }
    var headerObject = new Object();
    headerObject.Authorization = "Basic " + new Buffer.from(process.env.REACT_APP_USERNAME_CINEMA_APP + ":" + process.env.REACT_APP_PASSWORD_CINEMA_APP).toString("base64");
    headerObject.appplatform = "WEBSITE";
    headerObject.appversion = "1.0.0";
    headerObject.dataversion = dataversion;
    return new Promise((resolve, reject) => {
      axios({
        url: process.env.REACT_APP_BASEURL + "" + URL,
        method: methodType,
        headers: headerObject,
        data: data,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((ex) => {
          if (ex.response.data.message == "الحساب غير مفعل.") {
            console.log("matches");
          } else {
            console.log(ex.response.data.message);
            console.log("not matches");
          }
          reject({error: regexErrorMessage(ex.response.data.message)});
        });
    });
  }
}

function regexErrorMessage(errorMessage) {
  //tried to validate the error messages but spliting the text if it contains error code 500
  // var formatErrorMessage = isNaN(errorMessage.substring(0, 1)) ? errorMessage : errorMessage.split("-")[1].trim();
  // return isNaN(errorMessage.substring(0, 1)) ? errorMessage : formatErrorMessage.substring(1, formatErrorMessage.length - 1);

  return errorMessage;
}

export async function getAccessToken(username, password, keepmesignedin = true) {
  console.log(username);
  var headerObject = new Object();
  headerObject.Authorization = "Basic " + new Buffer.from(username + ":" + password).toString("base64");
  var data = new Object();
  data.accessTokenExpiry = accessTokenExpiry;
  data.keepMeSignedIn = keepmesignedin;
  data.getUserInfo = true;
  var dataversion = getCookie("muviDefalutlang");
  if (dataversion == "en") {
    dataversion = "en-US";
  } else if (dataversion == "ar") {
    dataversion = "ar-SA";
  } else {
    dataversion = "en-US";
  }
  headerObject.dataversion = dataversion;
  return new Promise((resolve, reject) => {
    axios({
      url: process.env.REACT_APP_BASEURL + "/user/v1/token",
      method: "POST",
      headers: headerObject,
      data: data,
    })
      .then((response) => {
        document.cookie = "accessToken=" + response.data.accessToken;
        document.cookie = "refreshToken=" + response.data.refreshToken;
        if (username != process.env.REACT_APP_USERNAME_CINEMA_APP) {
          document.cookie = "jwtoken=" + response.data.accessToken;
          document.cookie = "userPhoneNumber=" + response.data.phonenumber;
        }
        resolve(response);
      })
      .catch((ex) => {
        reject({error: ex.response});
      });
  });
}

function getRefreshToken() {
  var headerDetails = "Basic " + new Buffer.from(process.env.REACT_APP_USERNAME_CINEMA_APP + ":" + process.env.REACT_APP_PASSWORD_CINEMA_APP).toString("base64");
  var data = new Object();
  data.refreshToken = getCookie("refreshToken");
  data.accessTokenExpiry = accessTokenExpiry;
  data.keepmesignedin = true;
  data.getUserInfo = true;
  return new Promise((resolve, reject) => {
    axios({
      url: process.env.REACT_APP_BASEURL + "/user/v1/token/refresh",
      method: "POST",
      headers: {Authorization: headerDetails},
      data: data,
    })
      .then((response) => {
        document.cookie = "accessToken=" + response.data.accessToken;
        document.cookie = "refreshToken=" + response.data.refreshToken;
        resolve(response);
      })
      .catch((ex) => {
        if (axios.isCancel(ex)) {
          reject({Cancel: ""});
        } else if (ex.response.data.message.toLowerCase() == "token invalid") {
          getAccessToken(process.env.REACT_APP_USERNAME_CINEMA_APP, process.env.REACT_APP_PASSWORD_CINEMA_APP).then((response) => {
            callEndpoint(methodType, authorisationType, URL, data)
              .then((response) => {
                resolve(response);
              })
              .catch(reject);
          });
        }
      });
  });
}

export async function checkIfUserLoggedIn() {
  return getCookie("jwtoken");
}

export function getValueFromCookie(cookieName) {
  return getCookie(cookieName);
}

function getCookie(name) {
  var cookieArr = document.cookie.split(";");
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");
    if (name === cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}
